/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Add_CardInputs */

const en_plan_add_card = /** @type {(inputs: Plan_Add_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add card`)
};

const es_plan_add_card = /** @type {(inputs: Plan_Add_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir tarjeta`)
};

/**
* | output |
* | --- |
* | "Add card" |
*
* @param {Plan_Add_CardInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_add_card = /** @type {((inputs?: Plan_Add_CardInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Add_CardInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_add_card(inputs)
	return en_plan_add_card(inputs)
});